import { HttpInterceptorFn } from '@angular/common/http';
import { HttpMethod } from '../constants/http.constants';
import { emptyStringsToNull } from '../misc/helper-functions.utils';

export const processRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const body = req.body as unknown;
  const isFormData = body && body instanceof FormData;
  if (
    [HttpMethod.Patch, HttpMethod.Post, HttpMethod.Put, HttpMethod.Delete].includes(req.method as HttpMethod) &&
    req.body &&
    !isFormData
  )
    req = req.clone({
      body: emptyStringsToNull(req.body as Record<string, unknown>),
    });

  return next(req);
};
